module.exports = __webpack_public_path__ + "img/homepage-content-image-nissan.e1c20d08.jpg";